import React, { Component } from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from "../../color-constants";

const ToggleSwitchButton = styled.span`
  content: '';
  position: absolute;
  top: 2px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  transition: 0.2s;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  background-color: #fff;
  ${props => props.checked ? `right: 2px;` : `left: 2px;`}
`;

const ToggleSwitchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 30px;
  height: 15px;
  background: grey;
  border-radius: 100px;
  position: relative;
  transition: background-color .2s;
  ${props => props.checked ? `background-color: ${PRIMARY_COLOR};` : `background-color: grey;`}
  ${props => props.isDisabled && `pointer-events: none; opacity: 0.5;`}
`;

class ToggleSwitch extends Component {

  static propTypes = {
    isDisabled: PropTypes.bool,
    checked: PropTypes.bool,
    onToggle: PropTypes.func
  }


  render() {
    return (
      <>
        <ToggleSwitchLabel
          isDisabled={this.props.isDisabled}
          checked={this.props.checked}
          onClick={() => {
            this.props.onToggle(!this.props.checked);
          }}
        >
          <ToggleSwitchButton checked={this.props.checked}></ToggleSwitchButton>
        </ToggleSwitchLabel>
      </>
    );
  }
}

export default ToggleSwitch
